export var UnitType;
(function (UnitType) {
    // Land units
    UnitType["HOPLITE"] = "HOPLITE";
    UnitType["SWORDSMAN"] = "SWORDSMAN";
    UnitType["ARCHER"] = "ARCHER";
    UnitType["CAVALRY"] = "CAVALRY";
    UnitType["CATAPULT"] = "CATAPULT";
    // Naval units
    UnitType["CARGO_SHIP"] = "CARGO_SHIP";
    UnitType["WAR_SHIP"] = "WAR_SHIP";
})(UnitType || (UnitType = {}));
//# sourceMappingURL=units.js.map